import React from 'react';
interface ServiceCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
}
const ServiceCard: React.FC<ServiceCardProps> = ({
  title,
  description,
  icon
}) => {
  return <div className="bg-white p-6 md:p-8 rounded-lg shadow-md transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg border-t-4 border-[#c8a951]" data-id="element-72">
      <div className="text-[#c8a951] mb-4" data-id="element-73">{icon}</div>
      <h3 className="text-xl font-serif mb-3 text-[#1a2542]" data-id="element-74">{title}</h3>
      <p className="text-gray-600" data-id="element-75">{description}</p>
    </div>;
};
export default ServiceCard;